import gql from 'graphql-tag';

export const RemoveSecondaryIdentifier = gql`
  mutation ctgLoyaltyRemoveSecondaryIdentifier(
    $loyaltyId: String!
    $identifier: String!
    $identifierType: String!
  ) {
    ctgLoyaltyRemoveSecondaryIdentifier(
      loyaltyId: $loyaltyId
      identifier: $identifier
      identifierType: $identifierType
    ) {
      loyaltyId
      identifier
      identifierType
    }
  }
`;
